import React from 'react'
import Text from '@navent-jobs/ui-kit/components/text'
import ModalAvisosSugeridos from '../../../../../modals/modal-avisos-sugeridos'
import { FinalizadoContainer, WordingContainer } from './mixins'

const Component = ({ subarea, estado, visibleModal, hideModal, urlMaker }) => {
  const offline = estado === 'offline'

  return (
    <>
      <WordingContainer>
        <FinalizadoContainer>
          <Text variant="gray60" size="lg" fontWeight="semibold" as="h1">
            {offline ? 'La empresa finalizó este aviso' : 'Aviso finalizado'}
          </Text>
        </FinalizadoContainer>
      </WordingContainer>

      <ModalAvisosSugeridos
        id="moda-avisos-sugeridos"
        subarea={subarea}
        width={796}
        visible={visibleModal === 'modal-avisos-sugeridos'}
        closeModal={hideModal}
        urlMaker={urlMaker}
      />
    </>
  )
}

export default Component
